import { useMutation, useQuery, useQueryClient } from 'react-query';
import queries from '../queries';

const useCompressorEdit = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }) => {
      return queries.compressors.edit.query(id, data);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.compressors.get.key);
        queryClient.invalidateQueries(queries.companies.list.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useCompressorCreate = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (data) => {
      return queries.compressors.create.query(data);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.compressors.get.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useCompressorDelete = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id }) => {
      return queries.compressors.delete.query(id);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.compressors.get.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useCompressorTemplates = (params = {}, callbacks = {}) => {
  return useQuery([queries.compressors.getTemplates.key, params], () => queries.compressors.getTemplates.query(params), {
    ...callbacks,
    enabled: callbacks.enabled !== false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    keepPreviousData: true, // Keep previous data while loading new data
    select: (data) => {
      const result = queries.compressors.getTemplates.mapper(data);
      return {
        ...result,
        templates: result.templates.map((template) => ({
          ...template,
          label: `${template.compressorModel}, ${template.compressorMake}`,
          value: template.id,
        })),
      };
    },
  });
};

const useCompressorDatasheet = (id, callbacks = {}) => {
  return useQuery([queries.compressors.getDatasheet.key, id], () => queries.compressors.getDatasheet.query(id), {
    ...callbacks,
    enabled: callbacks.enabled !== false && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    select: (data) => {
      return queries.compressors.getDatasheet.mapper(data);
    },
  });
};

export default {
  useCompressorCreate,
  useCompressorEdit,
  useCompressorDelete,
  useCompressorTemplates,
  useCompressorDatasheet,
};
